import { observer } from 'mobx-react-lite'
import React from 'react'
import Input from '../../../../FormComponents/Input'

export default observer(function SurveryLink({ values, handleChange, handleBlur }) {

  return (
    <div className="bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-2xl p-4 mt-4">
      <p className="font-bold text-xl dark:text-white">Survery Link</p>
      <>
        <Input
          label="Title"
          className={!values.survey_link_visible && 'bg-gray-100 dark:bg-rb-dark-mode-lighter'}
          placeholder="Write something here"
          name='survey_link_title'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.survey_link_title}
        />

        <Input
          label="Link"
          className={!values.survey_link_visible && 'bg-gray-100 dark:bg-rb-dark-mode-lighter'}
          placeholder="Write something here"
          name='survey_link'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.survey_link}
        />
      </>

    </div>
  )
})